import { render, staticRenderFns } from "./SlidesCarousel.vue?vue&type=template&id=8822be74&scoped=true&"
import script from "./SlidesCarousel.vue?vue&type=script&lang=js&"
export * from "./SlidesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SlidesCarousel.vue?vue&type=style&index=0&id=8822be74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8822be74",
  null
  
)

export default component.exports